module.exports = __webpack_public_path__ + "img/ico_checkout_date.c1f5a5e6.svg";